import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

// Teal/red accents already used ad hoc (hex + !important) on several pages
// for "positive assignment" and destructive actions — centralized here so
// callers pick a variant instead of redefining a button skin per page.
const ACCENT_TEAL = "#279191";
const ACCENT_TEAL_HOVER = "#1a6e6e";
const DANGER_RED = "#ef4444";

const VARIANT_MAP = {
  primary: { variant: "contained", fullWidth: true },
  secondary: { variant: "outlined", fullWidth: true },
  smallprimary: { variant: "contained", size: "small" },
  smallsecondary: { variant: "outlined", size: "small" },
  accent: {
    variant: "contained",
    size: "small",
    color: "inherit",
    sx: {
      backgroundColor: ACCENT_TEAL,
      color: "#ffffff",
      "&:hover": { backgroundColor: ACCENT_TEAL_HOVER },
    },
  },
  "outline-danger": {
    variant: "outlined",
    size: "small",
    color: "inherit",
    sx: {
      borderColor: DANGER_RED,
      color: DANGER_RED,
      "&:hover": { backgroundColor: "rgba(239, 68, 68, 0.04)", borderColor: DANGER_RED },
    },
  },
  "outline-warning": {
    variant: "outlined",
    size: "small",
    color: "inherit",
    sx: {
      borderColor: "#d97706",
      color: "#d97706",
      fontWeight: 600,
      "&:hover": { backgroundColor: "rgba(217, 119, 6, 0.08)", borderColor: "#b45309" },
    },
  },
};

const Buttons = ({ text, type, onClick, className, variant, style, disabled, icon, fullWidth, ariaLabel, loading }) => {
  const config = VARIANT_MAP[variant] || VARIANT_MAP.primary;
  const spinnerSize = config.size === "small" ? 14 : 18;

  // No label — an icon-only control (back arrow, refresh, close, etc).
  if (!text) {
    return (
      <IconButton
        type={type}
        onClick={onClick}
        className={className}
        style={style}
        disabled={disabled || loading}
        size={config.size}
        aria-label={ariaLabel}
      >
        {loading ? <CircularProgress size={spinnerSize} color="inherit" /> : icon}
      </IconButton>
    );
  }

  return (
    <Button
      type={type}
      onClick={onClick}
      variant={config.variant}
      color={config.color || "primary"}
      fullWidth={fullWidth ?? config.fullWidth}
      size={config.size}
      className={className}
      style={style}
      sx={config.sx}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={spinnerSize} color="inherit" /> : icon}
    >
      {text}
    </Button>
  );
};

export default Buttons;
